import { PageRequest } from '@/components/table/types/PageRequest.ts';

export const buildPageRequestParams = (
  pageRequest: PageRequest,
): URLSearchParams => {
  const params = new URLSearchParams();
  params.append('page', pageRequest.page.toString());
  params.append('size', pageRequest.size.toString());
  if (pageRequest.sortByFieldId) {
    params.append('sortByFieldId', pageRequest.sortByFieldId);
  }
  if (pageRequest.sortDirection) {
    params.append('sortDirection', pageRequest.sortDirection);
  }
  return params;
};
